import { render, staticRenderFns } from "./ReSignPage.vue?vue&type=template&id=3c9da2b8&scoped=true&"
import script from "./ReSignPage.vue?vue&type=script&lang=js&"
export * from "./ReSignPage.vue?vue&type=script&lang=js&"
import style0 from "./ReSignPage.vue?vue&type=style&index=0&id=3c9da2b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9da2b8",
  null
  
)

export default component.exports